import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner/banner.component';
import { MarkdownModule } from 'src/app/pipes/markdown/markdown.module';
import { SafeHtmlModule } from 'src/app/pipes/safehtml/safehtml.module';

@NgModule({
	declarations: [BannerComponent],
	imports: [CommonModule, MarkdownModule, SafeHtmlModule],
	exports: [BannerComponent]
})
export class BannerModule {}
